import { ComponentProps, FC } from 'react'
import { Button, DialogTitle, ModalCenter, useAnalytic } from 'src/components'
import { ETrackingEvent } from 'src/enums'

interface IProps extends ComponentProps<typeof ModalCenter> {
  onDelete?: () => void
}

export const ConfirmDeleteCampaignPopup: FC<IProps> = ({ onDelete, ...props }) => {
  const { eventHandler } = useAnalytic('my_jobs')

  return (
    <ModalCenter
      {...props}
      contentStyles={{ width: 424 }}
    >
      <div className="fx-column fx-center gap-12 txt-center">
        <div className="fx-column gap-2">
          <DialogTitle className="py-3">Delete This Job?</DialogTitle>
          <div className="fx-column gap-2">
            <div className="fs-14 fw-700 lh-20 txt-negative-600">
              This action CANNOT be undone.
            </div>
            <div className="body-14 txt-black-02">
              This job and its applicants will be permanently removed and you
              won’t be able to see them again.
            </div>
          </div>
        </div>
        <div className="fx-column gap-3 w-100-p">
          <Button
            className="py-3"
            onClick={eventHandler(ETrackingEvent.BTN_CONFIRM_DELETE_JOB, () => {
              onDelete?.()
              props.onClose?.()
            })}
          >
            Yes, Delete
          </Button>
          <Button
            variant="secondary"
            className="py-3"
            onClick={eventHandler(ETrackingEvent.BTN_CANCEL_DELETE_JOB, () => props.onClose?.())}
          >
            Cancel
          </Button>
        </div>
      </div>
    </ModalCenter>
  )
}
